import React from "react";
import {
  AgreementToggle,
  PurposeConsentWrapper,
} from "../styledComponents/agreementStyles/agreement.style";
import { useTranslation } from "react-i18next";

const MarketingPurposeConsent = ({
  header = null,
  text = null,
  handleClick = () => {},
  isAgreed = false,
}) => {
  const { t } = useTranslation();
  return (
    <PurposeConsentWrapper>
      <AgreementToggle onClick={handleClick} isAgreed={isAgreed} />

      <div>
        {header || <h6>{t("consent_mark_purpose_header")}</h6>}
        <p>{text}</p>
      </div>
    </PurposeConsentWrapper>
  );
};

export default MarketingPurposeConsent;
